import React from 'react'

const ArrowIcon = () => {
  return <i className='fa-light fa-arrow-right'></i>
}

export default ArrowIcon